"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendItemsLabels = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var legend_labels_1 = require("../../layout/utils/legend_labels");
var get_partition_specs_1 = require("./get_partition_specs");
var tree_1 = require("./tree");
exports.getLegendItemsLabels = re_reselect_1.default([get_partition_specs_1.getPartitionSpecs, get_settings_specs_1.getSettingsSpecSelector, tree_1.getTrees], function (specs, _a, trees) {
    var legendMaxDepth = _a.legendMaxDepth, showLegend = _a.showLegend;
    return specs.flatMap(function (spec) {
        return showLegend ? trees.flatMap(function (_a) {
            var tree = _a.tree;
            return legend_labels_1.getLegendLabels(spec.layers, tree, legendMaxDepth);
        }) : [];
    });
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_legend_items_labels.js.map